import { useDashboard } from '@/hooks'

/**
 * Whether this user may choose between the Fresh and Timescale back ends.
 *
 * Granted by staff on the admin user detail page and stored on the profile, which the
 * dashboard configuration already carries — so this costs no extra request. The server
 * restores the flag from the stored row on every profile save, so editing it client-side
 * only hides or shows a control; it grants nothing.
 */
const useCanSelectDataSource = (): boolean => {
  const { configuration } = useDashboard()
  return configuration?.can_select_data_source === true
}

export default useCanSelectDataSource
